import script from "./NummulitesView.vue?vue&type=script&setup=true&lang=js"
export * from "./NummulitesView.vue?vue&type=script&setup=true&lang=js"

import "./NummulitesView.vue?vue&type=style&index=0&id=3e342974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e342974"]])

export default __exports__